var _excluded = ["show", "onAdd", "toggle"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Button from "../../../core/components/Button";
import Input from "../../../core/form/fields/Input";
var AddColumnModal = function AddColumnModal(_ref) {
  var show = _ref.show,
    onAdd = _ref.onAdd,
    toggle = _ref.toggle,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    columnValue = _useState2[0],
    setColumnValue = _useState2[1];
  var _useState3 = useState(3),
    _useState4 = _slicedToArray(_useState3, 2),
    columnPoint = _useState4[0],
    setColumnPoint = _useState4[1];
  var handleSave = function handleSave() {
    onAdd({
      title: columnValue,
      point: columnPoint
    });
  };
  useEffect(function () {
    if (!show) setColumnValue('');
  }, [show]);
  return /*#__PURE__*/React.createElement(Modal, Object.assign({
    isOpen: show,
    toggle: toggle,
    zIndex: 21800000000
  }, otherProps), /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: toggle,
    charcode: "x",
    tag: "h4"
  }, "Add a column"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Input, {
    label: "Column name",
    value: columnValue,
    onChange: function onChange(e) {
      return setColumnValue(e.currentTarget.value);
    }
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Input, {
    type: "number",
    label: "Point",
    value: columnPoint,
    onChange: function onChange(e) {
      return setColumnPoint(e.currentTarget.value);
    }
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSave
  }, "Add")));
};
AddColumnModal.defaultProps = {
  toggle: undefined
};
export default AddColumnModal;